import { axios, Response } from '../index'
import { GetConfigurationPublicationsResponse } from './get-configurationPublications'

const checkConfigurationPublicationsCategories = (
  publisherId: string,
  categoryId: string
): Response<GetConfigurationPublicationsResponse> => {
  return axios.put(
    `/v1/publisher-settings/${publisherId}/categories/${categoryId}`
  )
}

export default checkConfigurationPublicationsCategories
